import axios from 'axios';
import { awsConfig } from '../aws-config';
import { fetchAuthSession } from 'aws-amplify/auth';

// Create axios instance with API Gateway endpoint
const apiClient = axios.create({
  baseURL: awsConfig.apiEndpoint,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper function to get trial status
export const getTrialStatus = async () => {
  try {
    const response = await apiClient.get('/trial-status');
    return response.data;
  } catch (error) {
    console.error('Error fetching trial status:', error);
    return {
      isPremium: false,
      trialTopicsRemaining: 0,
      trialWritingRemaining: 0,
      hasTrialAccess: false
    };
  }
};

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
      
      // If user is not authenticated, redirect to login
      if (error.name === 'UserUnAuthenticatedException' || 
          error.message?.includes('not authenticated')) {
        // Clear any stored user data
        localStorage.removeItem('user');
        // Redirect to login
        window.location.href = '/login';
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response?.status === 401) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || '';
      
      // Check if it's an unverified user error
      if (errorMessage.includes('not confirmed') || 
          errorMessage.includes('not verified') ||
          errorMessage.includes('User needs to be authenticated')) {
        // Clear stored user
        const storedUser = localStorage.getItem('user');
        let userEmail = '';
        
        if (storedUser) {
          try {
            const userData = JSON.parse(storedUser);
            userEmail = userData.email;
          } catch (e) {
            console.error('Error parsing user data:', e);
          }
        }
        
        localStorage.removeItem('user');
        
        // Store email for verification page if available
        if (userEmail) {
          sessionStorage.setItem('verificationEmail', userEmail);
        }
        
        // Show alert and redirect to verification
        alert('⚠️ Email Verification Required\n\nYour email needs to be verified before you can access this feature.\n\nPlease check your email for the verification code or request a new one.');
        window.location.href = '/resend-verification';
        return Promise.reject(error);
      }
      
      // Generic authentication error
      localStorage.removeItem('user');
      alert('Your session has expired. Please login again.');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
